<template>
  <div>
      <div class="columns">
          <div class="column has-text-centered">
              <h1 class="has-text-white is-size-3">COMPANY APPROVALS</h1>
          </div>
      </div>
      <div class="columns is-vcentered">
        <div v-if="companies.length===0" class="column has-text-centered has-text-dvogreen">
          <h1 class="is-size-5">There are no companies currently awaiting approval</h1>
      </div>
        <div v-else class="column">
        <b-table :data="companies" paginated :per-page="10" :current-page.sync="currentPage"
            :pagination-simple="false" pagination-position="bottom" striped>
            <b-table-column field="name" label="Company Name" width="40" searchable v-slot="props">
                {{ props.row.name }}
            </b-table-column>
            <b-table-column field="address" label="Company Address" width="40" searchable v-slot="props">
                {{ props.row.address }}
            </b-table-column>
            <b-table-column field="main_contact_email" label="Contact Email" width="40" sortable
                v-slot="props">
                {{ props.row.main_contact_email }}
            </b-table-column>
            <b-table-column field="phone_number" label="Phone Number" width="40" sortable
                v-slot="props">
                {{ props.row.phone_number }}
            </b-table-column>
            <b-table-column field="id" label="Approve" width="40" numeric v-slot="props">
                <i @click="companyApprovalModal(props.row.id, props.row.principal_person)"
                    class="fas fa-check-square has-text-dvogreen"></i>
            </b-table-column>
            <b-table-column field="id" label="Decline" width="40" numeric v-slot="props">
                <i @click="rejectCompany(props.row.id)"
                    class="far fa-times-circle has-text-dvogreen"></i>
            </b-table-column>
        </b-table>
      </div>
      </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify'
import { companyHandler } from '../graphql/mutations'
import { companyReader } from '../graphql/queries'
import companyApprovalModal from './CompanyRatesApproval'

export default {
    data(){
        return{
            companies: [],
            currentPage: 1,
        }
    },
    methods:{
        async getCompanies() {
            console.log('called')
            const Companies = await API.graphql({
                query: companyReader,
                variables: {
                    input: {
                        request_type: 'new_company_requests'
                    }
                }
            });
            this.companies = Companies.data.companyReader;
        },
         companyApprovalModal(id, requester_id) {
            this.$buefy.modal.open({
                parent: this,
                component: companyApprovalModal,
                hasModalCard: true,
                trapFocus: true,
                props:{
                    initId: id,
                    initRequester: requester_id
                },
                events:{
                    'refresh': async()=>{
                        console.log('refresh')
                        await this.getCompanies()
                    },
                    'close': async ()  => {
                        // console.log('close')
                        // await new Promise(r => setTimeout(r, 2000));
                        // console.log('waited')
                        await this.getCompanies()
                    }
                }
            })
        },
        async rejectCompany(id) {
            const apiReturn = await API.graphql({
                query: companyHandler,
                variables: {
                    input: {
                        id: id,
                        request_type: 'delete'
                    }
                }
            });
            const temp = apiReturn.data.companyHandler
            this.companies = this.companies.filter(obj => obj.id != temp.id);
        },
    },
    async mounted() {
        this.getCompanies()
    }
}
</script>

<style>

</style>